module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "modal-mask",
    attrs: {
      "role": "dialog"
    }
  }, [_c('div', {
    staticClass: "overlay-mask"
  }, [_c('div', {
    staticClass: "modal-dialog modal-sm"
  }, [_c('div', {
    staticClass: "modal-content g-mt-170"
  }, [_c('div', {
    staticClass: "modal-body"
  }, [_c('div', {
    staticClass: "close_btn",
    on: {
      "click": function($event) {
        return _vm.Close()
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "row g-my-20 g-mx-20"
  }, [_c('div', {
    staticClass: "col-lg-12 col-md-12 col-sm-12 col-xs-12 g-my-15"
  }, [_c('label', [_vm._v("E-Order #:")]), _c('span', [_vm._v(" " + _vm._s(_vm.orderNumber))]), _c('br'), _vm._v(" "), _c('label', [_vm._v("Status:")]), _c('span', [_vm._v(" " + _vm._s(_vm.visionWebOrderStatus))]), _c('br'), _vm._v(" "), _c('label', [_vm._v("Last Updated:")]), _c('span', [_vm._v(" " + _vm._s(_vm.FormatDateToLocal(_vm.dateSubmitted)))]), _c('br')]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-12 col-md-12 col-sm-12 col-xs-12 center"
  }, [_c('button', {
    staticClass: "btn g-color-white g-bg-main g-bg-primary--hover g-rounded-10 g-btn-130",
    on: {
      "click": function($event) {
        return _vm.Close()
      }
    }
  }, [_vm._v("Close")])])])])])])])])])
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-576ec926", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-576ec926"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/portal/OrderTracking/OrderTrackingComponents/OrderTrackingVisionWebStatus.vue
// module id = 526
// module chunks = 4